<div class="popup-wrapper">
  <div class="popup-header">
    <h2 class="popup-title">Refund Request Preview</h2>
    <button class="custom-close" (click)="closePopup()">×</button>
  </div>

  <div class="popup-body">
    <!-- Main Details -->
    <!-- Order Information Section -->
    <div class="section-title">Order Information</div>
    <div class="info-grid-2col">
      <div class="info-row">
        <div class="label">Name</div>
        <div class="value">{{ orderData.user_name || "N/A" }}</div>
      </div>
      <div class="info-row">
        <div class="label">Email</div>
        <div class="value">{{ orderData.user_email || "N/A" }}</div>
      </div>

      <div class="info-row">
        <div class="label">Order</div>
        <div class="value">{{ orderData.order_name || "N/A" }}</div>
      </div>
      <div class="info-row">
        <div class="label">Request Type</div>
        <div class="value">{{ orderData.request_type || "N/A" }}</div>
      </div>

      <div class="info-row">
        <div class="label">Status</div>
        <div class="value">{{ orderData.refund_request_status || "N/A" }}</div>
      </div>
    </div>

    <!-- Products Section -->
    <div class="section-title" *ngIf="orderData.products?.length > 0">
      Products
    </div>

    <div
      class="product-card"
      *ngFor="let product of orderData.products; let i = index"
    >
      <img
        [src]="
          product.product_image ||
          'https://all-frontend-assets.s3.us-east-1.amazonaws.com/divine-infinity-being/custom_button_icons_image/logo_placeholder.png'
        "
        alt="Product"
      />
      <div class="product-details">
        <div *ngIf="product.name">
          <strong>Name:</strong> <span>{{ product.name }}</span>
        </div>
        <div *ngIf="product.quantity">
          <strong>Qty:</strong> <span>{{ product.quantity }}</span>
        </div>
        <div *ngIf="product.price">
          <strong>Price:</strong> <span>${{ product.price }}</span>
        </div>
        <div *ngIf="product.selected_size">
          <strong>Size:</strong> <span>{{ product.selected_size }}</span>
        </div>
        <div *ngIf="product.selected_color">
          <strong>Color:</strong> <span>{{ product.selected_color }}</span>
        </div>
      </div>
    </div>

    <!-- Media Section -->
    <div
      class="section-title"
      *ngIf="
        orderData.media?.image?.length > 0 || orderData.media?.video?.length > 0
      "
    >
      Media
    </div>

    <!-- Images Section -->
    <div class="sub-section-title-row">
      <div class="sub-section-title">Images</div>
      <button class="add-btn" (click)="addimageButtonClick()">
        + Add Images
      </button>
    </div>

    <div class="media-back">
      <div
        class="media-grid"
        *ngIf="orderData.media?.image?.length > 0; else noImages"
      >
        <div
          class="media-card"
          *ngFor="let img of orderData.media.image; let i = index"
        >
          <div class="media-center">
            <img
              [src]="
                'https://' +
                img.bucket +
                '.s3.amazonaws.com/' +
                img.baseurl +
                img.fileservername
              "
              alt="Media Image"
              class="media-thumb"
            />
            <button
              class="fullscreen-btn"
              (click)="openFullscreen($event, 'image', img)"
            >
              ⛶
            </button>
          </div>
        </div>
      </div>

      <!-- Fallback when no images -->
      <ng-template #noImages>
        <div class="no-media-text">No images available</div>
      </ng-template>
    </div>

    <!-- Videos Section -->
    <div class="sub-section-title-row">
      <div class="sub-section-title">Videos</div>
      <button class="add-btn" (click)="addvideoButtonClick()">
        + Add Videos
      </button>
    </div>

    <div class="media-back">
      <div
        class="media-grid"
        *ngIf="orderData.media?.video?.length > 0; else noVideos"
      >
        <div
          class="media-card"
          *ngFor="let vid of orderData.media.video; let i = index"
        >
          <div class="media-center">
            <video
              [src]="
                'https://' +
                vid.bucket +
                '.s3.amazonaws.com/' +
                vid.baseurl +
                '/' +
                vid.fileservername
              "
              controls
              class="media-thumb"
            ></video>
            <button
              class="fullscreen-btn"
              (click)="openFullscreen($event, 'video', vid)"
            >
              ⛶
            </button>
          </div>
        </div>
      </div>

      <!-- Fallback when no videos -->
      <ng-template #noVideos>
        <div class="no-media-text">No videos available</div>
      </ng-template>
    </div>

    <!-- Comments Section -->
    <div class="section-title" *ngIf="orderData.returnComment?.length > 0">
      Comments
    </div>
    <div mat-dialog-content class="comment-section">
      <div *ngFor="let comment of commentData" class="comment-wrapper">
        <div
          class="comment-bubble"
          [ngClass]="{
            'customer-comment': comment.user_type === 'customer',
            'admin-comment': comment.user_type === 'is_admin'
          }"
        >
          <p class="comment-text">{{ comment.comment_text }}</p>
          <span class="comment-timestamp">{{
            comment.createdAt | date : "short"
          }}</span>
        </div>
      </div>

      <div *ngIf="commentData.length === 0" class="no-comments">
        No comments have been posted yet.
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="comment-input-area">
      <textarea
        class="comment-textarea-field"
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
        placeholder="Type your Comment..."
        [(ngModel)]="newCommentText"
        (keyup.enter)="!isSubmitting && addComment()"
      ></textarea>

      <button
        class="comment_send_btn"
        (click)="addComment()"
        [disabled]="isSubmitting"
        [attr.aria-busy]="isSubmitting ? 'true' : null"
      ></button>
    </div>
  </div>
</div>

<!-- Fullscreen Modal -->
<div
  class="fullscreen-overlay"
  [style.display]="isFullscreen ? 'flex' : 'none'"
  (click)="closeFullscreen()"
>
  <div class="fullscreen-content" (click)="$event.stopPropagation()">
    <img
      *ngIf="fullscreenType === 'image'"
      [src]="fullscreenSrc"
      alt="Fullscreen image"
    />
    <video
      *ngIf="fullscreenType === 'video'"
      [src]="fullscreenSrc"
      controls
      autoplay
    ></video>
    <button class="close-fullscreen" (click)="closeFullscreen()">✕</button>
  </div>
</div>
